export const MKT_STATUS_TYPE = {
	awaitingBids: 'awaitingBids',
	nonStartedBuyerBid: 'nonStartedBuyerBid',
	leader: 'leader',
	outbid: 'outbid',
	otherLeader: 'otherLeader',
	won: 'won',
	sold: 'sold',
	lost: 'lost',
	sellerIsLastCounter: 'sellerIsLastCounter',
	buyerIsLastCounter: 'buyerIsLastCounter',
	endedOnOffer: 'endedOnOffer',
	failed: 'failed',
	expired: 'expired',
};
